import { FC, useEffect, useState } from 'react';
import { createBlobFromAnUrl } from '../FileManager/ItemsViewer/DocumentViewerModal/DocumentViewModal';
import {
  LoadingContainer,
  LoadingProgress,
} from '../FileManager/ItemsViewer/DocumentViewerModal/styles';
import { convertDigitToProperFormat } from '../../utils/number';

interface IPdfViewerProps {
  pdfURL: string;
  name: string;
}

const PdfViewer: FC<IPdfViewerProps> = ({ pdfURL, name }) => {
  const [pdfBlobURL, setPdfBlobURL] = useState<string | null>(null);
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    createBlobFromAnUrl(pdfURL, 'application/pdf', (p) => {
      setProgress(p);
    })
      .then((blobURL: any) => {
        setPdfBlobURL(blobURL as string);
      })
      .catch((error) => console.error('Error fetching Blob URL:', error));
  }, [pdfURL]);

  return (
    <div className="h-full overflow-hidden">
      {pdfBlobURL === null ? (
        <LoadingContainer>
          <LoadingProgress>
            <div>
              {convertDigitToProperFormat(progress)}
              <span> % </span>
            </div>
            <div className="progress">
              <div className="determinate" style={{ width: progress + '%' }} />
            </div>
          </LoadingProgress>
        </LoadingContainer>
      ) : (
        <iframe
          id="pdfFrame"
          title={name as string}
          style={{ height: '100%', width: '100%', minHeight: '70vh' }}
          src={pdfBlobURL ? pdfBlobURL : ''}
        />
      )}
    </div>
  );
};

export default PdfViewer;
